import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import permissionRoutes from '../../../components/permission/permissionRoutes';

const update = createAsyncThunk(
  'thunk/permission/read',
  async (arg, thunkAPI) => {
    const response = await apiFetch(permissionRoutes.api.generate.read(arg?.id), {
      method: 'GET',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
